module.exports = __webpack_public_path__ + "static/media/service.f64bd6a2.jpg";